/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 商家让利账单列表 的 **请求配置**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ReturnProfitBill/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家让利账单列表 的 **请求函数**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 让利账单列表初始化参数 的 **请求配置**
 *
 * @分类 财务API/商家账单
 * @请求头 `GET /erp/ReturnProfitBill/sectionInitOption`
 */
const getSectionInitOptionRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ReturnProfitBill/sectionInitOption",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getSectionInitOption",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 让利账单列表初始化参数 的 **请求函数**
 *
 * @分类 财务API/商家账单
 * @请求头 `GET /erp/ReturnProfitBill/sectionInitOption`
 */
export const getSectionInitOption = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getSectionInitOptionRequestConfig, requestData),
    ...args
  );
};
getSectionInitOption.requestConfig = getSectionInitOptionRequestConfig;
/**
 * 接口 让利佣金账单详情 的 **请求配置**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/getBillDetail`
 */
const postGetBillDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ReturnProfitBill/getBillDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBillDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 让利佣金账单详情 的 **请求函数**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/getBillDetail`
 */
export const postGetBillDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetBillDetailRequestConfig, requestData), ...args);
};
postGetBillDetail.requestConfig = postGetBillDetailRequestConfig;
/**
 * 接口 作废让利账单 的 **请求配置**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/cancelReturnBill`
 */
const postCancelReturnBillRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ReturnProfitBill/cancelReturnBill",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCancelReturnBill",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 作废让利账单 的 **请求函数**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/cancelReturnBill`
 */
export const postCancelReturnBill = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCancelReturnBillRequestConfig, requestData),
    ...args
  );
};
postCancelReturnBill.requestConfig = postCancelReturnBillRequestConfig;
/**
 * 接口 让利账单-上传回执 的 **请求配置**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/uploadReceipt`
 */
const postUploadReceiptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/ReturnProfitBill/uploadReceipt",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUploadReceipt",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 让利账单-上传回执 的 **请求函数**
 *
 * @分类 财务API/商家账单
 * @请求头 `POST /erp/ReturnProfitBill/uploadReceipt`
 */
export const postUploadReceipt = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUploadReceiptRequestConfig, requestData), ...args);
};
postUploadReceipt.requestConfig = postUploadReceiptRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/ReturnProfitBill.js